/* eslint-disable no-restricted-globals */
import { history } from '../_helpers';
export const accessControlsServices = {
  createAccessControl,
  getAccessControlsDetails,
  getAccessControlsList,
  getActiveRoleList,
  getAccessControlsPolicesList,
  applyAccessControlsFilters,
  getAccessControlsTopCard,
  getAccessControlsFilters,
  updateAccessControl,
  activateAccessRole,
  assignAccessControlPolicies,
  deleteRole,
  fetchAllUiNavigation,
  assignUiNavigation,
  UiNavigationById,
  fetchPoliciesById,
  unassignUiNavigation,
  searchAccessControls
};

function createAccessControl(formData) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": user.accessToken,
      "content-type": "application/json",
    },
    body: JSON.stringify(formData),
  };


  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/roles`,
    requestOptions
  ).then(handleResponse);
}

function assignAccessControlPolicies(polices, accessControlId) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "PUT",
    headers: {
      "x-access-token": user.accessToken,
      "content-type": "application/json",
    },
    body: JSON.stringify(polices),
  };


  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/policies/assign/${accessControlId}`,
    requestOptions
  ).then(handleResponse);
}

function getAccessControlsPolicesList(roleId) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/policies/${roleId}`,
    requestOptions
  ).then(handleResponse);
}

function getAccessControlsDetails(accessControlId) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };


  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/role/${accessControlId}`,
    requestOptions
  ).then(handleResponse);
}

function getAccessControlsList(offset=0, limit=10) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/roles/${offset}/${limit}`,
    requestOptions
  ).then(handleResponse);
}

function getActiveRoleList() {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/roles/active`,
    requestOptions
  ).then(handleResponse);
}

function getAccessControlsTopCard() {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };


  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/roles/cards`,
    requestOptions
  ).then(handleResponse);
}

function getAccessControlsFilters() {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/roles/filter/props/`,
    requestOptions
  ).then(handleResponse);
}
//updateAccessControl
function updateAccessControl(formData, roleId) {
  let user = JSON.parse(localStorage.getItem('user'));
  const requestOptions = {
    method: "PUT",
    headers: {
      'x-access-token': user.accessToken,
      'content-type': 'application/json'
    },
    body: JSON.stringify(formData),
  }
  return fetch(`${process.env.REACT_APP_BACKEND_API_URL}/api/v1/roles/${roleId}`, requestOptions).then(handleResponse)
}
function applyAccessControlsFilters(
  type,
  user,
  status,
  startDate,
  endDate,
  search,
  offset,
  limit,
) {
  let users = JSON.parse(localStorage.getItem("user"));
  const sortBy = "DESC";
  const columnName = "updatedAt";
  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": users.accessToken,
      "content-type": "application/json",
    },
    body: JSON.stringify({
      type,
      user,
      status,
      startDate,
      endDate,
      search,
    }),
  };


  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/roles/filter/${limit}/${offset}/${sortBy}/${columnName}`,
    requestOptions
  ).then(handleResponse);
}

function activateAccessRole(isActive, roleId) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "PUT",
    headers: {
      "x-access-token": user.accessToken,
      "content-type": "application/json",
    },
    body: JSON.stringify({ isActive }),
  };


  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/roles/activate/${roleId}`,
    requestOptions
  ).then(handleResponse);
}
//fetchAllUiNavigation
function fetchAllUiNavigation() {
  let user = JSON.parse(localStorage.getItem('user'));
  const requestOptions = {
    method: "GET",
    headers: {
      'x-access-token': user.accessToken,
    }
  }
  return fetch(`${process.env.REACT_APP_BACKEND_API_URL}/api/v1/roles/policies/pages`,
   requestOptions).then(handleResponse)
}

//assignUiNavigation
function assignUiNavigation(uiNavigation, roleId) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "PUT",
    headers: {
      'x-access-token': user.accessToken,
      'content-type': 'application/json',
    },
    body: JSON.stringify(uiNavigation),
  }
  return fetch(`${process.env.REACT_APP_BACKEND_API_URL}/api/v1/roles/policies/pages/assign/${roleId}`,
    requestOptions).then(handleResponse)
}
//UiNavigationById
function UiNavigationById(roleId) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      'x-access-token': user.accessToken,
    },
  }
  return fetch(`${process.env.REACT_APP_BACKEND_API_URL}/api/v1/roles/policies/pages/${roleId}`,
    requestOptions).then(handleResponse)
}
//fetchPoliciesById
function fetchPoliciesById(roleId) {
  let user = JSON.parse(localStorage.getItem('user'))
  const requestOptions = {
    method: "GET",
    headers: {
      'x-access-token': user.accessToken,
    },
  }
  return fetch(`${process.env.REACT_APP_BACKEND_API_URL}/api/v1/roles/policy/${roleId}`, requestOptions).then(handleResponse)
}
//unassignUiNavigation
function unassignUiNavigation(uiNavigation, roleId) {
  let user = JSON.parse(localStorage.getItem('user'))
  const requestOptions = {
    method: "PUT",
    headers: {
      'x-access-token': user.accessToken,
      'content-type': 'application/json',
    },
    body: JSON.stringify(uiNavigation)
  }
  return fetch(`${process.env.REACT_APP_BACKEND_API_URL}/api/v1/roles/policies/pages/unassign/${roleId}`, requestOptions).then(handleResponse)
}

function searchAccessControls(search, offset, limit) {
   let user = JSON.parse(localStorage.getItem('user'))
  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": user.accessToken,
      "content-type": "application/json",
    },
    body: JSON.stringify({
      search,
      offset,
      limit
    }),
  };
  return fetch(`${process.env.REACT_APP_BACKEND_API_URL}/api/v1/roles/search/${offset}/${limit}`, requestOptions).then(handleResponse);
}

function handleResponse(response) {
  return response.text().then((text) => {
    const data = text && JSON.parse(text);


    if (!response.ok) {
      if (response.status === 401) {
        // auto logout if 401 response returned from api
        // logout();
        // location.reload(true);
      }
      // checking token expiry
      if (response.status === 401 && data.message.includes('Invalid JWT token')) {
        //redirecting to signin page
        history.push('/auth/signin')
        //removing local storage token
        localStorage.removeItem('user');
        return;
      }
      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}

//Deleting Roles

function deleteRole(roleId) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "DELETE",
    headers: {
      "x-access-token": user.accessToken,
      "content-type": "application/json",
    },
  };


  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/roles/${roleId}`,
    requestOptions
  ).then(handleResponse);
}

